// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".d\\+9Xz{display:block}.d\\+9Xz .nlRFn{padding-top:8px}@media screen and (min-width:768px){.d\\+9Xz .nlRFn{padding:16px 0 0}}.d\\+9Xz .nlRFn[data-first]{padding-top:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"brandVoice": "d+9Xz",
	"grid": "nlRFn"
};
module.exports = ___CSS_LOADER_EXPORT___;
